import { asyncConnect } from 'redux-connect';
import { EnvironmentTypeSelector } from '../components/EnvironmentTypeSelector';

const mapStateToProps = state => ({
  ...state,
  currentProvider: state.idAdmin.currentProvider
});

export default asyncConnect([], mapStateToProps)(EnvironmentTypeSelector);
